export default __webpack_public_path__ + "static/media/m_use_action_zc.708ba3ed.png";